export function BruteForceDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.BRUTE_FORCE)
        .setCustomActions({
            'getConfig': {
                method: 'GET'
            },
            'setConfig': {
                method: 'POST',
            },
            'unlockUser': {
                method: 'GET',
                params: {param: '@userID'},
                path: XRAY_RESOURCE.USERS + '/unlock/:param'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/brute_force_dao.js